import React, { useContext, useEffect } from 'react';
import { Col, Image, Row } from 'react-bootstrap';
import waveBg from 'assets/img/illustrations/bg-wave.png';
import AppContext from 'context/Context';
import CompanyBanner from './CompanyBanner';
import ContactCompany from './ContactCompany';
import CompanyDescp from './CompanyDescp';
//import ProjectGallery from './ProjectGallery';
//import ProjectReviews from './ProjectReviews';
//import SimilarProjects from './SimilarProjects';
import { useParams } from 'react-router-dom';
import useCompany from '../useCompany';
import CompanyAddress from './CompanyAddress';

const ProfileCompany = () => {
 const {
  auth,
  config: { navbarPosition },
  setConfig,
  configDispatch
 } = useContext(AppContext);

 const { id } = useParams();
 const company = id ? id : auth.company ? auth?.company?.id : 1;

 const { data } = useCompany(company);

 useEffect(() => {
  return () => {
   setConfig('disabledNavbarPosition', ['vertical', 'combo']);
   if (!/double-top|top/.test(navbarPosition))
    configDispatch({ type: 'SET_CONFIG', payload: { key: 'navbarPosition', value: 'top' } });
   configDispatch({ type: 'SET_CONFIG', payload: { key: 'isFluid', value: false } });
  };
 }, []);

 return (
  data && (
   <>
    <CompanyBanner data={data} />
    <Row className="g-lg-3">
     <Col lg={8} className="order-1 order-lg-0">
      <CompanyDescp data={data} />
      <CompanyAddress data={data} />
      {/* <ProjectQualities data={dataProject.qualities} /> */}
      {/* <ProjectGallery images={dataProject.images} /> */}
      {/* <ProjectReviews data={courseReviews} /> */}
      {/*  <SimilarProjects /> */}
     </Col>
     <Col lg={4}>
      <div className="course-details-sticky-sidebar mb-lg-8 mt-xl-n10 pe-xl-4 pe-xxl-7">
       <ContactCompany data={data} />
       <div className="d-none d-xl-block position-absolute z-index--1 top-0 end-0 text-end me-n2 me-xxl-4 mt-xl-6">
        <Image src={waveBg} alt="" style={{ maxWidth: '23.75rem' }} className="bg-card" />
       </div>
      </div>
     </Col>
    </Row>
   </>
  )
 );
};

export default ProfileCompany;
